import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'animate.css'
import anime from 'animejs'
import './assets/styles/global.css'

// 引入Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false

// 注册Element UI
Vue.use(ElementUI)

// 全局挂载anime.js
window.anime = anime

// 全局挂载jQuery
import $ from 'jquery'
window.$ = $
window.jQuery = $

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
